import emptyIcon from 'assets/account_circle.svg'
import placeHolderImage from 'assets/PorscheCar.svg'
import { onFormatDate } from 'components'
import { DownloadLink } from 'components/DownloadLink'
import { useDownloadBlobLinkMutation } from 'components/DownloadLink/DownloadLink.generated'
import { Box } from 'grid'
import { LinkType, Wiki } from 'model'
import {
  DocumentCard,
  DocumentCardActivity,
  DocumentCardDetails,
  DocumentCardPreview,
  DocumentCardTitle,
  DocumentCardType,
  ImageFit,
  ISelection,
  SelectionMode,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import sanitizeHtml from 'sanitize-html'
import { useTheme } from 'theme'
import './wikiElement.css'

export enum FILE_COMPONENTS {
  uri,
  fileName,
}
export function getProperty(type: FILE_COMPONENTS, compositeString: string) {
  let result = ''
  switch (type) {
    case FILE_COMPONENTS.uri:
      result = compositeString.split(' ')[0]
      break
    case FILE_COMPONENTS.fileName:
      result = compositeString.split(' ').slice(1).join('')
      break
    default:
      break
  }
  return result
}
interface ISelectionItemExampleProps {
  item: Wiki & { key: string }
  itemIndex?: number
  selection?: ISelection
  selectionMode?: SelectionMode
  onShowHandler: () => void
  newElement: boolean
}
// const trimDate = (dateString: string) => {
//   const dateObj = new Date(dateString)
//   const month = dateObj.getUTCMonth() + 1 // months from 1-12
//   const day = dateObj.getUTCDate()
//   const year = dateObj.getUTCFullYear()
//   return year + '/' + month + '/' + day
// }
const checkIfAvailableForDisplay = (item: Wiki & { key: string }) => {
  const supportedValues = ['img', 'png', 'svg', 'jpg', 'jpeg', 'jfif']
  if (!item.filePreview) {
    return false
  }
  const value = getProperty(FILE_COMPONENTS.fileName, item.filePreview)
    .split('.')
    .slice(-1)
    .pop()
  if (value && supportedValues.includes(value.toLocaleLowerCase())) {
    return true
  } else {
    return false
  }
}

export const WikiListSingleView: React.FC<ISelectionItemExampleProps> = (
  props: ISelectionItemExampleProps
) => {
  const { item, itemIndex, selection, onShowHandler, newElement } = props
  let isSelected = false
  const { t } = useTranslation()
  const theme = useTheme()

  if (selection && itemIndex !== undefined) {
    isSelected = selection.isIndexSelected(itemIndex)
  }
  const displayPreview = checkIfAvailableForDisplay(item)

  const [downloadBlobLink] = useDownloadBlobLinkMutation()
  const [linkState, setLinkState] = useState()

  const getLink = React.useCallback(
    async (uri: string) => {
      if (!linkState) {
        const blobLinkRes = await downloadBlobLink({
          variables: {
            uri,
            expiresIn: 7776000,
            linkType: LinkType.Shared,
          },
        })
        setLinkState(blobLinkRes.data ? blobLinkRes.data.downloadBlobLink : '')
      }
    },
    [downloadBlobLink, setLinkState, linkState]
  )

  React.useEffect(() => {
    if (item.filePreview) {
      getLink(getProperty(FILE_COMPONENTS.uri, item.filePreview))
    }
  }, [item.filePreview, getLink])

  return (
    <div data-selection-index={itemIndex}>
      {selection &&
        selection.canSelectItem(item) &&
        selection.mode !== SelectionMode.none && (
          <div>
            <DocumentCard
              style={{
                outlineStyle: `${isSelected ? 'solid' : 'none'} !important`,
                outlineColor: 'blue',
                outlineWidth: '2px',
              }}
              aria-label="File Document Card "
              type={DocumentCardType.normal}
              key={item.key}
              onFocusCapture={(e) => {
                e.preventDefault()
              }}
              onClick={(e) => {
                selection.setIndexSelected(itemIndex!, !isSelected, false)
              }}
              onDoubleClick={() => {
                onShowHandler()
              }}

              // &&(item.fileName!.split('.').slice(-1).pop()=='jpg')
            >
              <DocumentCardPreview
                {...{
                  previewImages: [
                    {
                      previewImageSrc: displayPreview
                        ? linkState
                        : placeHolderImage,
                      imageFit: ImageFit.cover,
                      width: 318,
                      height: 196,
                    },
                  ],
                }}
              />
              <DocumentCardDetails
                styles={{
                  root: {
                    backgroundColor: newElement
                      ? theme.palette.themeLighterAlt
                      : 'white',
                  },
                }}
              >
                <DocumentCardTitle title={item.topic} shouldTruncate={true} />
                {/* <DocumentCardTitle
                  title={item.body || ''}
                  shouldTruncate={true}
                  showAsSecondaryTitle={true}
                /> */}
                <Box p="8px 16px">
                  {item.body
                    ? sanitizeHtml(item.body, {
                        allowedTags: [],
                        allowedAttributes: {},
                      }).slice(0, 40) + (item.body.length > 40 ? '...' : '')
                    : ''}
                </Box>
                {item.files && item.files.length === 1 ? (
                  <DownloadLink
                    styles={{
                      root: { alignSelf: 'start', paddingLeft: '1vw' },
                    }}
                    uri={getProperty(FILE_COMPONENTS.uri, item.files[0]) || ''}
                  >
                    {getProperty(FILE_COMPONENTS.fileName, item.files[0]) || ''}
                  </DownloadLink>
                ) : item.files && item.files.length > 1 ? (
                  <div
                    style={{
                      alignSelf: 'start',
                      paddingLeft: '0.6vw',
                      color: 'rgb(213, 0, 28)',
                    }}
                  >
                    Mehrere Dateien...
                  </div>
                ) : (
                  <br />
                )}
                <DocumentCardActivity
                  activity={`${t('field.modified.label')} ${onFormatDate(
                    new Date(item.modified)
                  )}`}
                  people={[
                    { name: item.modifiedBy!.name, profileImageSrc: emptyIcon },
                  ]}
                />
              </DocumentCardDetails>
            </DocumentCard>
          </div>
        )}
    </div>
  )
}
